import React from 'react';
import { TextField, TextFieldProps, createStyles, withStyles } from '@material-ui/core';
import { primaryGreen } from 'src/data/colors';

export const BaseInput = withStyles(() =>
  createStyles({
    root: {
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: primaryGreen,
        },
        '&:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': {
          borderColor: primaryGreen,
        },
      },
      '& .MuiInputLabel-root.Mui-focused': {
        color: primaryGreen,
      },
    },
  })
)((props: TextFieldProps) => (
  <TextField {...props} variant="outlined" />
)) as React.FC<TextFieldProps>;
